module.exports = __webpack_public_path__ + "media/images/chat/avatar_placeholder_male-5a021d23ab2e5b55017b7bee5acff22b.png";